// use .env, but how?
const baseConfig = {
  apiKey: 'blt7d4c4f4a1bf5a819',
  url: 'https://graphql.contentstack.com'
};

const config = {
  dev: {
    ...baseConfig,
    accessToken: 'cs74599c107573ea7f6c7a1413',
    env: 'public-dev'
  },
  prod: {
    ...baseConfig,
    accessToken: 'cs7029c5e32f0e99978efc683d',
    env: 'public-prod'
  },
  test: {
    ...baseConfig,
    accessToken: 'cs67e9fdd60eb15c301add40ea',
    env: 'public-test'
  }
};

/**
 * getCredentials returns contentstack config.
 *
 * @param {string} env
 * @return {{accessToken: string; apiKey: string; env: string; url: string;}} 
 */
function getCredentials(env) {
  if (config[env] === undefined) {
    return {};
  }

  return config[env];
}

module.exports = {
  getCredentials
}
